// Privacy Policy 页面组件 - 简洁白色样式
import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* 头部导航 */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Register
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          <p className="text-gray-600 mt-2">
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* 内容 */}
        <div className="prose max-w-none">
          <div className="space-y-8 text-gray-800">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
              <p className="mb-3">We collect the following types of information:</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li><strong>Account Information:</strong> Email address, username, and encrypted passwords</li>
                <li><strong>Usage Data:</strong> API calls, request patterns, and service usage statistics</li>
                <li><strong>Payment Information:</strong> Processed securely through Stripe (we don't store card details)</li>
                <li><strong>Technical Data:</strong> IP addresses, browser information, and device identifiers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Provide and improve our AI platform services</li>
                <li>Process payments and manage your account</li>
                <li>Monitor system performance and prevent abuse</li>
                <li>Comply with legal obligations and security requirements</li>
                <li>Send important service updates and notifications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Data Sharing and Disclosure</h2>
              <p className="mb-3">We do not sell your personal data. We may share information only in these situations:</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li><strong>Third-party Services:</strong> Stripe for payment processing, cloud providers for infrastructure</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                <li><strong>Business Transfer:</strong> In case of merger, acquisition, or sale of assets</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
              <p className="mb-4">
                We implement industry-standard security measures including encryption in transit and at rest, 
                secure API authentication, and regular security audits to protect your information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Your Rights</h2>
              <p className="mb-3">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Access and review your personal information</li>
                <li>Request corrections to inaccurate data</li>
                <li>Delete your account and associated data</li>
                <li>Export your usage data and statistics</li>
                <li>Opt out of non-essential communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Data Retention</h2>
              <p className="mb-4">
                We retain your information for as long as your account is active or as needed to provide services. 
                Usage logs are kept for 90 days for security and debugging purposes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. International Data Transfers</h2>
              <p className="mb-4">
                Your data may be processed in the United States and other countries where we or our service 
                providers operate, with appropriate safeguards in place.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Contact Us</h2>
              <p className="mb-4">
                For privacy-related questions or requests, contact us at privacy@yourdomain.com or through 
                your account dashboard.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy